import { render, staticRenderFns } from "./InvoicePaid.vue?vue&type=template&id=b5d3e756"
import script from "./InvoicePaid.vue?vue&type=script&lang=js"
export * from "./InvoicePaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports